import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessToken: "",
  user: null,
};

const authSlice = createSlice({
  initialState,
  name: "auth",
  reducers: {
    loginUser: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.user = action.payload.user;
    },
    logoutUser: () => {
      return initialState;
    },
  },
});

export default authSlice.reducer;
export const { loginUser, logoutUser } = authSlice.actions;

export const authSelector = (state) => state.auth;
